import * as React from 'react';
import {Button} from 'antd';

interface IProps {
  message: string;
  actionMsg: string;
  action: () => void;
}

export const FormMessage = ((props: IProps) => {

  return (
    <div style={{textAlign: 'center'}}>
      <br/>
      <h4>
        <span>{props.message}</span>
      </h4>
      <Button onClick={props.action}>{props.actionMsg}</Button>
    </div>
  )
});
